// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wheel_game__uP7oR {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.wheel_inner__7GWrO {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 70px;
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
}
.wheel_main-game__nkEa6 {
  border-radius: 50%;
  margin-top: 40px;
  z-index: 100;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wheel_wheel__jBS6o {
  max-width: 357px;
  max-height: 357px;
  min-width: 267px;
  min-height: 267px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: var(
    --Yalda-Btn,
    linear-gradient(217deg, #c80b14 33.4%, #df4051 92.35%)
  ); */
  z-index: -1;
}
.wheel_wheel__jBS6o img {
}
.wheel_main-wheel__NxUtF {
  position: absolute;
  z-index: -1;
  /* min-width: 328px;
  min-height: 328px; */
}
.wheel_arrow-wheel__OEPJ- {
  position: absolute;
  top: 8px;
}
.wheel_arrow-wheel__OEPJ- img {
  width: 32px;
}
.wheel_stand__p0Y95 {
  position: absolute;
  z-index: -2;
  bottom: -44px;
}
.wheel_circle__1ZgSu {
  min-width: 328px;
  min-height: 328px;
}
.wheel_change__NRQx9 {
  height: 56px;
}
.wheel_change__NRQx9 span {
  font-size: 16px !important;
}
.wheel_shadow__3vn0G {
  position: absolute;
  bottom: -103px;
}
.wheel_title__\\+KbgL {
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 111.111% */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}
.wheel_category__kijcG {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  width: fit-content;
  padding: 4px 12px;
}
.wheel_category-title__8xdzD {
  color: #fff;
  text-align: center;
  /* font-family: Yekan Bakh VF; */
  font-size: 14px;
  font-style: normal;
  font-weight: 325;
  line-height: 20px;
}
.wheel_category-dadge__IbBHE {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  /* font-family: Yekan Bakh VF; */
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 24px;
  gap: 2px;
}
.wheel_category-dadge__IbBHE img {
  max-width: 32px;
}
.wheel_title-row__OvkO3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;
}
.wheel_special-chance-board-container__PAAgr {
  width: 100%;
  z-index: 100;
}
@media screen and (min-width: 1200px) {
  .wheel_wheel__jBS6o {
    max-width: 400px;
    max-height: 400px;
    min-width: 400px;
    min-height: 400px;
  }
  .wheel_inner__7GWrO {
    padding-bottom: 100px;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }
  .wheel_inner-desktop__0T7zf {
    max-width: 900px;
  }
  .wheel_title-row__OvkO3 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin-top: 22px;
    width: 360px;
  }
  .wheel_title__\\+KbgL {
    font-size: 20px;
  }
  .wheel_game__uP7oR {
    width: 100%;
  }

  .wheel_arrow-wheel__OEPJ- img {
    width: 47px;
  }
  .wheel_special-chance-board-container__PAAgr {
    width: 34%;
    z-index: 100;
    margin-top: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/wheel/wheel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;;;MAGI;EACJ,WAAW;AACb;AACA;AACA;AACA;EACE,kBAAkB;EAClB,WAAW;EACX;sBACoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".game {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 70px;\n  padding-right: 16px;\n  padding-left: 16px;\n  width: 100%;\n}\n.main-game {\n  border-radius: 50%;\n  margin-top: 40px;\n  z-index: 100;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.wheel {\n  max-width: 357px;\n  max-height: 357px;\n  min-width: 267px;\n  min-height: 267px;\n  border-radius: 50%;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background: var(\n    --Yalda-Btn,\n    linear-gradient(217deg, #c80b14 33.4%, #df4051 92.35%)\n  ); */\n  z-index: -1;\n}\n.wheel img {\n}\n.main-wheel {\n  position: absolute;\n  z-index: -1;\n  /* min-width: 328px;\n  min-height: 328px; */\n}\n.arrow-wheel {\n  position: absolute;\n  top: 8px;\n}\n.arrow-wheel img {\n  width: 32px;\n}\n.stand {\n  position: absolute;\n  z-index: -2;\n  bottom: -44px;\n}\n.circle {\n  min-width: 328px;\n  min-height: 328px;\n}\n.change {\n  height: 56px;\n}\n.change span {\n  font-size: 16px !important;\n}\n.shadow {\n  position: absolute;\n  bottom: -103px;\n}\n.title {\n  color: #fff;\n  text-align: center;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 111.111% */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px;\n}\n.category {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 8px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.1);\n  width: fit-content;\n  padding: 4px 12px;\n}\n.category-title {\n  color: #fff;\n  text-align: center;\n  /* font-family: Yekan Bakh VF; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 20px;\n}\n.category-dadge {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  text-align: center;\n  /* font-family: Yekan Bakh VF; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 24px;\n  gap: 2px;\n}\n.category-dadge img {\n  max-width: 32px;\n}\n.title-row {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 500px;\n}\n.special-chance-board-container {\n  width: 100%;\n  z-index: 100;\n}\n@media screen and (min-width: 1200px) {\n  .wheel {\n    max-width: 400px;\n    max-height: 400px;\n    min-width: 400px;\n    min-height: 400px;\n  }\n  .inner {\n    padding-bottom: 100px;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 24px;\n  }\n  .inner-desktop {\n    max-width: 900px;\n  }\n  .title-row {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n    margin-top: 22px;\n    width: 360px;\n  }\n  .title {\n    font-size: 20px;\n  }\n  .game {\n    width: 100%;\n  }\n\n  .arrow-wheel img {\n    width: 47px;\n  }\n  .special-chance-board-container {\n    width: 34%;\n    z-index: 100;\n    margin-top: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"game": `wheel_game__uP7oR`,
	"inner": `wheel_inner__7GWrO`,
	"main-game": `wheel_main-game__nkEa6`,
	"wheel": `wheel_wheel__jBS6o`,
	"main-wheel": `wheel_main-wheel__NxUtF`,
	"arrow-wheel": `wheel_arrow-wheel__OEPJ-`,
	"stand": `wheel_stand__p0Y95`,
	"circle": `wheel_circle__1ZgSu`,
	"change": `wheel_change__NRQx9`,
	"shadow": `wheel_shadow__3vn0G`,
	"title": `wheel_title__+KbgL`,
	"category": `wheel_category__kijcG`,
	"category-title": `wheel_category-title__8xdzD`,
	"category-dadge": `wheel_category-dadge__IbBHE`,
	"title-row": `wheel_title-row__OvkO3`,
	"special-chance-board-container": `wheel_special-chance-board-container__PAAgr`,
	"inner-desktop": `wheel_inner-desktop__0T7zf`
};
export default ___CSS_LOADER_EXPORT___;
